import { render, staticRenderFns } from "./homeAdvertising.vue?vue&type=template&id=628c35ee&scoped=true"
import script from "./homeAdvertising.vue?vue&type=script&lang=js"
export * from "./homeAdvertising.vue?vue&type=script&lang=js"
import style0 from "./homeAdvertising.vue?vue&type=style&index=0&id=628c35ee&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c35ee",
  null
  
)

export default component.exports